<mat-form-field [appearance]="matAppearance">
  <mat-label>{{ label }}</mat-label>
  <input [id]="componentId" matInput [formControl]="fc" trim="blur" />
</mat-form-field>
